import PropTypes from 'prop-types'
import React, {useMemo} from 'react'
import {useContext, useState} from 'react'

/**
 * This is the context for managing leap overlay.
 */
const LeapOverlayContext = React.createContext(null)

/**
 * Hook to access the LeapOverlayContext.
 */
const useLeapOverlay = ({anchor} = {}) => {
    const context = useContext(LeapOverlayContext)
    if (!context) throw new Error('useLeapOverlay must be used within a LeapOverlayProvider')

    const isOpen = Boolean(anchor && context.currentOverlay === anchor)

    return {
        ...context,
        isOpen
    }
}
export default useLeapOverlay

/**
 * Provider for the LeapOverlayContext.
 * @param children
 */
export const LeapOverlayProvider = ({children}) => {
    const [currentOverlay, setCurrentOverlay] = useState(null)

    const api = useMemo(
        () => ({
            currentOverlay: currentOverlay,
            onOpen: (anchor) => {
                if (!anchor) return
                setCurrentOverlay(anchor)
            },
            onClose: () => {
                setCurrentOverlay(null)
            }
        }),

        [currentOverlay]
    )

    return <LeapOverlayContext.Provider value={api}>{children}</LeapOverlayContext.Provider>
}

LeapOverlayProvider.propTypes = {
    children: PropTypes.node
}
